<web-design-system-modal [headline]="'lombard.edit.headline' | transloco" (dismiss)="modal.close()">
  @if (facade.lombard$ | async; as lombard) {
    {{ 'lombard.edit.body' | transloco }}
    <div class="mt-4 mb-4 input-group-material select-dropdown">
      <select #creditLines (change)="handleDropdownChange($event, creditLines.value)">
        @for (credit of lombard.creditChangePossibleAmounts; track $index) {
          <option [value]="credit">{{ credit | currency: 'EUR' : 'symbol' : '1.0-0' }}</option>
        }
      </select>
    </div>
    <div class="text-size-large mb-2" [innerHTML]="'lombard.edit.legal' | transloco"></div>
    <div class="text-size-large font-bold mb-4">
      {{ 'lombard.edit.hint' | transloco }}
    </div>
    @if (facade.error$ | async; as error) {
      <div class="mt-4 mb-4">
        <div class="text-color-error">{{ error }}</div>
      </div>
    }
    <web-design-system-button
      [fullwidth]="true"
      [disabled]="facade.applying$ | async"
      (click)="applyForCredit(lombard.creditChangePossibleAmounts[0])"
    >
      {{ 'lombard.edit.button' | transloco }}
    </web-design-system-button>
  }
</web-design-system-modal>
